// Rikki Broadmore coaches clinic — free/public masterclass.
// Swap in the Mux playback ID + flesh out notes when the clinic is uploaded.

export const RIKKI_MODULE_KEY = "rikki-broadmore-clinic";

const VIDEOS = {
  clinic: "O72XF02yreOx6G35D6ryBi6LNtyh01Fk02e2cuxyPfcPas",
};

// Titles are matched case-insensitively against the `drills` table in the
// `drillCollection` block. Keep these in sync with the Content Manager —
// if a drill is renamed there it'll silently drop off the masterclass page
// (a console.warn flags missing matches in dev).
const RIKKI_DRILL_TITLES = [
  "Choose Your Physicality Warmup",
  "Push Ballhandling Warmup",
  "Song Twitchy 1v1",
  "Back Foot Twitchy 1v1",
  "Front Foot Twitchy 1v1 with Driving Line",
  "Driving Line Unpredictability 1v1",
  "Close Quarters Physicality Pressure Handling",
  "Spin or Straight Line 1v2 (or 1v1)",
  "Side On Pass Attacks",
  "Creativity 1v2",
  "Angled Closeout Attack for Efficiency",
  "Mid Range Separation Contested Shooting",
  "Trailing Defender Fast 1v2 Series",
  "Hit Find Get Rebounding",
];

export const RIKKI_MODULE = {
  key: RIKKI_MODULE_KEY,
 title: "Rikki Broadmore: Coaches Clinic",
  // Gives the shelf card a real frame from this masterclass instead of the
  // shared mc-art SVG. See masterclass/coverArt.js.
  coverVideoId: VIDEOS.clinic,
  sub: "A full coaches clinic from Rikki Broadmore, free for anyone on a platform preview.",
  duration: "Full clinic",
  chapters: [
    {
      id: "clinic",
      title: "The Clinic",
      blocks: [
        { kind: "text", md:
 "This is a full coaches clinic from Rikki Broadmore: made available free as a preview of what's inside By Any Means Coaches. Watch end-to-end, take notes, and keep what's useful." },
        { kind: "video", muxPlaybackId: VIDEOS.clinic,
 caption: "Rikki Broadmore: Full Coaches Clinic." },
        { kind: "text", md:
 "If you want more, full libraries of drills, team-coaching insights, X&O breakdowns, practice plans, and additional masterclasses, you can explore the full platform below." },
      ],
    },
    {
      id: "drills",
      title: "Signature Drills",
      blocks: [
        { kind: "text", md:
          "Some of Rikki's go-to's, pulled from a full workout filmed before the clinic. Each is short, sharp, and built to run with yours tomorrow. Tap a card to play the standalone breakdown." },
        {
          kind: "drillCollection",
          title: "Signature Drills",
          subtitle: RIKKI_DRILL_TITLES.length + " drills · in the order Rikki ran them.",
          titles: RIKKI_DRILL_TITLES,
        },
      ],
    },
  ],
};
